import React, { useState, useEffect } from "react";

export default function useTableService(totalRecords, headCells, noHeight, callbacks) {
  const pages = [10, 25, 50, 100];
  const [page, setPage] = useState(0); // Siempre iniciar en 0
  const [rowsPerPage, setRowsPerPage] = useState(pages[0]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();

  const TblContainer = (props) => (
    <div
      style={{
        maxHeight: noHeight ? "auto" : "calc(100vh - 430px)",
        minHeight: noHeight ? "auto" : "calc(100vh - 430px)",
        overflowY: "auto",
        width: "100%",
      }}
    >
      <table className="table table-striped table-hover table-sm px-2">
        {props.children}
      </table>
    </div>
  );

  // Resetear a la página 0 si cambia el total de registros (ej. al buscar)
  useEffect(() => {
    setPage(0);
  }, [totalRecords]);

  const TblHead = (props) => {
    const handleSortRequest = (cellId) => {
      const isAsc = orderBy === cellId && order === "asc";
      const newOrder = isAsc ? "desc" : "asc";
      setOrder(newOrder);
      setOrderBy(cellId);
      // Avisar al padre que cambió el orden
      if (callbacks && callbacks.onSortChange) {
        callbacks.onSortChange(cellId, newOrder);
      }
    };

    return (
      <thead>
        <tr>
          {headCells.map((headCell) => (
            <th
              className="letra-tabla-th"
              key={headCell.id}
              style={{
                fontFamily: headCell.fontFamily,
                textAlign: headCell.textAlign,
                fontWeight: "bold",
                backgroundColor: headCell.backgroundColor,
                color: headCell.color,
                fontSize: "12px",
                padding: headCell.padding,
                margin: headCell.margin,
                cursor: headCell.disableSorting ? "default" : "pointer"
              }}
              onClick={() => {
                if (!headCell.disableSorting) handleSortRequest(headCell.id);
              }}
            >
              {headCell.label}
            </th>
          ))}
        </tr>
      </thead>
    );
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
    if (callbacks && callbacks.onPageChange) {
      callbacks.onPageChange(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0); // Al cambiar límite, siempre volver a página 0
    if (callbacks && callbacks.onRowsPerPageChange) {
      callbacks.onRowsPerPageChange(newLimit);
    }
  };

  const TblPagination = () => {
    const totalPages = Math.ceil(totalRecords / rowsPerPage);
    const startIndex = totalRecords === 0 ? 0 : page * rowsPerPage + 1;
    const endIndex = Math.min(totalRecords, (page + 1) * rowsPerPage);

    return (
      <div className="pagination">
        <div className="pagination-info my-auto px-2">
          Filas {startIndex}–{endIndex} de {totalRecords}
        </div>
        <button
          onClick={() => handleChangePage(page - 1)}
          disabled={page === 0}
        >
          <i className="fas fa-caret-left"></i>
        </button>
        <button
          onClick={() => handleChangePage(page + 1)}
          disabled={page >= totalPages - 1}
        >
          <i className="fas fa-caret-right"></i>
        </button>

        <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
          {pages.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {pageSize}
            </option>
          ))}
        </select>
      </div>
    );
  };

  // Ya no hace falta stableSort ni getComparator porque el backend ordena.
  // Simplemente retornamos los componentes UI.
  return {
    TblContainer,
    TblHead,
    TblPagination,
  };
}